import React from 'react';
import { Form, Input, InputNumber } from 'antd';
// Constants
import { MONTH_LABEL_PATTERN } from './constants';

type ProgramFormFieldsProps = {
  isEdit: boolean;
};

const ProgramFormFields: React.FC<ProgramFormFieldsProps> = ({ isEdit }) => (
  <>
    <Form.Item
      name="monthLabel"
      label="Month (YYYY-MM)"
      rules={[
        { required: true, message: 'Month label is required' },
        {
          pattern: MONTH_LABEL_PATTERN,
          message: 'Use YYYY-MM, e.g. 2026-06',
        },
      ]}
    >
      <Input placeholder="2026-06" disabled={isEdit} />
    </Form.Item>

    <Form.Item
      name="prizeAmount"
      label="Prize Amount (whole dollars)"
      rules={[{ required: true, message: 'Prize amount is required' }]}
    >
      <InputNumber min={0} style={{ width: '100%' }} placeholder="500" />
    </Form.Item>

    <Form.Item
      name="prizeCurrency"
      label="Currency"
      rules={[{ required: true, message: 'Currency is required' }]}
    >
      <Input placeholder="USD" />
    </Form.Item>

    <Form.Item
      name="slotsPerMonth"
      label="Slots per month (UI display only)"
      rules={[{ required: true, message: 'Slots is required' }]}
    >
      <InputNumber min={0} style={{ width: '100%' }} placeholder="10" />
    </Form.Item>
  </>
);

export default ProgramFormFields;
